import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/order_refunds',
  component: Management,
  redirect: '/order_refunds/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/order_refunds/List'),
      redirect: 'list/all',
      meta: {
        auth: Auth.listOrderRefunds
      },
      children: [
        {
          path: 'all',
          component: () => import('@/views/order_refunds/ListTable'),
          meta: {
            auth: Auth.listOrderRefunds,
            tabName: 'all'
          }
        },
        {
          path: 'pending',
          component: () => import('@/views/order_refunds/ListTable'),
          meta: {
            auth: Auth.listOrderRefunds,
            tabName: 'pending'
          }
        },
        {
          path: 'passed',
          component: () => import('@/views/order_refunds/ListTable'),
          meta: {
            auth: Auth.listOrderRefunds,
            tabName: 'passed'
          }
        },
        {
          path: 'rejected',
          component: () => import('@/views/order_refunds/ListTable'),
          meta: {
            auth: Auth.listOrderRefunds,
            tabName: 'rejected'
          }
        }
      ]
    },
    // 新增
    {
      path: 'new',
      component: () => import('@/views/order_refunds/New'),
      meta: {
        auth: Auth.createOrderRefund
      }
    },
    // 详情
    {
      path: ':id',
      component: () => import('@/views/order_refunds/DetailLayout'),
      meta: {
        auth: Auth.showOrderRefund
      },
      children: [
        // 基本信息
        {
          path: 'detail',
          component: () => import('@/views/order_refunds/details/Detail'),
          meta: {
            tabName: 'detail', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showOrderRefund
          }
        }
      ]
    }
  ]
}
